import React from "react";
import { CHECKOUT_URL } from "../../data/links";
const links = ["Customer Support", "Refund Policy", "Privacy Policy", "Terms and Conditions"];
export function Footer() {
  return <footer className="border-t border-white/10 bg-navy-950 px-4 pb-32 pt-12 text-white sm:px-6" data-id="element-227" data-mp="2f4jtbv98lr03">
      <div className="mx-auto max-w-3xl text-center" data-id="element-228" data-mp="2a6085x2gwj8s">
        <p className="font-display text-3xl font-extrabold uppercase" data-id="element-229" data-mp="2a6ibterglzqq">Alopecia Clinical Blueprint™</p>
        <p className="mt-1 text-sm text-white/70" data-id="element-230" data-mp="1mgflb33711u8">An Educational Reference Collection by Dr. Daniel Mitchell</p>

        <div className="mt-8 rounded-2xl bg-navy-900 p-5 text-left text-xs leading-relaxed text-white/65" data-id="element-231" data-mp="1heyq9o7e49lk">
          <p className="mb-2 font-bold uppercase tracking-[0.12em] text-white/85" data-id="element-232" data-mp="1w7shu7zxsg6l">Important educational disclaimer</p>
          <div className="space-y-2" data-id="element-233" data-mp="13per0sd0puh0">
            <p data-id="element-234" data-mp="13odc2csvsnu0">ALOPECIA CLINICAL BLUEPRINT™ is intended for educational and professional reference purposes.</p>
            <p data-id="element-235" data-mp="yq21u0yocbb9">
              The 15-Minute Alopecia Assessment Framework™ is a proposed structure for organizing an
              initial review of available clinical information. The time allocation is a workflow
              target, not a validated clinical performance claim or guarantee.
            </p>
            <p data-id="element-236" data-mp="1ncgzm6fdsmdm">
              The materials do not provide medical diagnoses, treatment prescriptions, professional
              certification, or authorization to perform clinical procedures.
            </p>
            <p data-id="element-237" data-mp="vlklz3lhydpa">
              They do not replace professional qualifications, supervised training, individualized
              patient assessment, current clinical guidelines, diagnostic investigations, or
              emergency protocols.
            </p>
            <p data-id="element-238" data-mp="19jsemzbi2sun">
              Clinical decisions must be made by qualified healthcare professionals in accordance
              with current evidence, applicable regulations, and individual patient circumstances.
            </p>
            <p data-id="element-239" data-mp="2l08xz3q6dtms">
              All educational templates and resources should be reviewed and adapted to the
              practitioner’s professional scope and local requirements.
            </p>
          </div>
        </div>

        <nav aria-label="Legal" className="mt-8" data-id="element-240" data-mp="2586gp0zrprqo">
          <ul className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm" data-id="element-241" data-mp="256vdb2a8im03">
            {links.map(l => <li key={l} data-id="element-242" data-mp="209v78rddxj8z">
                <a href={CHECKOUT_URL} className="text-white/75 underline-offset-4 transition-colors duration-150 hover:text-white hover:underline" data-id="element-243" data-mp="1cjitv0zdeub0">
                  {l}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mt-6 text-xs text-white/50" data-id="element-244" data-mp="1ma3zv9hdj13y">© 2026 ALOPECIA CLINICAL BLUEPRINT™. All rights reserved.</p>
      </div>
    </footer>;
}